export function clearDemoScheduleLocal() {
  try {
    // Remove all local demo schedule/completion footprints
    Object.keys(localStorage)
      .filter(k => k.startsWith("demo:schedule:"))
      .forEach(k => localStorage.removeItem(k));
  } catch {}
}
